import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Spin } from "antd"
import { classNames } from "../../utils/classNames"

type Props = {
    size?: "large" | "small"
    style?: Maybe<Record<string, any>>
    opacity?: number
    caption?: Maybe<React.ReactNode>
    padding?: number | string
    className?: string
}

// Use new component from '../uiKit/LoadingOverlay.tsx' folder instead
/** @deprecated */
export class LoadingOverlayDeprecated extends React.PureComponent<Props> {
    static defaultProps = {
        padding: "10rem",
        size: "large",
    }

    render() {
        return (
            <div className={classNames("loading-overlay", this.props.className)} style={{ ...this.props.style }}>
                <Spin size={this.props.size} />
                {!this.props.caption ? null : <div className="loading-overlay__caption">{this.props.caption}</div>}
                <style jsx={true} global={true}>
                    {`
                        .loading-overlay {
                            text-align: center;
                            padding: ${this.props.padding || "10rem"};
                            width: 100%;
                            height: 100%;
                            background-color: rgba(255, 255, 255, ${this.props.opacity || 0.9});
                            position: absolute;
                            z-index: 50000;
                        }

                        .loading-overlay__caption {
                            opacity: 0.5;
                            margin-top: 1rem;
                        }
                    `}
                </style>
            </div>
        )
    }
}
